import React from 'react'

import { ActionModal } from './ActionModal/ActionModal'
import { ConfirmModal } from './ConfirmModal/ConfirmModal'
import { DataListModal } from './DataListModal/DataListModal'
import { DialogModal } from './DialogModal'
import { ExportModal } from './ExportModal'
import { FilterModal } from './FilterModal/FilterModal'
import { FromToRangeModal } from './FromToModal/FromToRangeModal'
import { InfoModal } from './InfoModal/InfoModal'
import { FailedMessageModal, MessageModal, SuccessMessageModal } from './MessageModal/MessageModal'
import { PageModal } from './PageModal/PageModal'
import { RadioModal } from './RadioModal/RadioModal'
import { SortModal } from './SortModal/SortModal'
import { ModalButton } from './common/components/ModalButton'

export type ModalComponent = React.FC<any>
export type CommonComponents = typeof commonComponents
export type ExtendedModal<T extends ModalComponent> = T & CommonComponents

const modals = {
  Sort: SortModal,
  Filter: FilterModal,
  DataList: DataListModal,
  Dialog: DialogModal,
  Page: PageModal,
  Radio: RadioModal,
  // RadioOption: RadioOptionModal,
  SuccessMessage: SuccessMessageModal,
  FailedMessage: FailedMessageModal,
  Action: ActionModal,
  FromToRange: FromToRangeModal,
  Confirm: ConfirmModal,
  Export: ExportModal,
  Info: InfoModal,
} as const

export const commonComponents = {
  Button: ModalButton,
} as const

const attachComponents = <T extends Record<string, ModalComponent>>(
  modals: T
): { [K in keyof T]: ExtendedModal<T[K]> } => {
  const entries = Object.entries(modals) as [keyof T, T[keyof T]][]
  return entries.reduce((acc, [key, modal]) => {
    acc[key] = Object.assign(modal, commonComponents)
    return acc
  }, {} as { [K in keyof T]: ExtendedModal<T[K]> })
}

export const Modal = attachComponents(modals)
